import { render, staticRenderFns } from "./NewCredentialsList.vue?vue&type=template&id=4233819c&scoped=true"
import script from "./NewCredentialsList.vue?vue&type=script&lang=js"
export * from "./NewCredentialsList.vue?vue&type=script&lang=js"
import style0 from "./NewCredentialsList.vue?vue&type=style&index=0&id=4233819c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4233819c",
  null
  
)

export default component.exports